<template>
  <section>
    <ul class="filters-list">
      <li
        :class="{
          'router-link-active-parent': $route.name == 'casesLogs',
        }"
      >
        <router-link :to="{ name: 'casesLogs', query: this.$route.query }">
          CASES
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'ordersLogs', query: this.$route.query }">
          ORDERS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'emrOrdersLogs', query: this.$route.query }">
          EMR ORDERS
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'resultFileLogs', query: this.$route.query }">
          RESULT FILES
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li>
        <router-link :to="{ name: 'generalLogs', query: this.$route.query }">
          GENERAL
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
      <li v-if="isSuperAdmin">
        <router-link :to="{ name: 'loginLogs', query: this.$route.query }">
          LOGIN
          <span class="active-icon">
            <img src="@/assets/images/caret-down-fill.svg" alt="" /> </span
        ></router-link>
      </li>
    </ul>
  </section>
</template>
<script>
import GlobalHelper from "@/mixins/GlobalHelper";
export default {
  mixins: [GlobalHelper],
};
</script>
